import { type CSSProperties, css } from 'styled-components';

export const FuuzeColors = {
  dark: {
    dark100: '#1C1C1C',
    dark200: '#333333',
    dark300: '#494949',
    dark400: '#606060',
    dark500: '#777777',
    dark600: '#8E8E8E',
    dark700: '#A4A4A4',
    dark800: '#BBBBBB',
    dark900: '#d2d2d2',
  },
  orange: {
    orange20: '#FFF4EB',
    orange30: '#FFEAD6',
    orange40: '#FFDFC2',
    orange50: '#FFD5AE',
    orange60: '#FFCA9A',
    orange70: '#FFBF85',
    orange80: '#FFB571',
    orange90: '#FFAA5D',
    orange100: '#ffa048',
  },
  background: '#161616',
  text: '#E8E8E8',
  yellow: '#FFD563',
  green: '#6FC469',
  red: '#f68a9b',
  white: '#ffffff',
  black: '#000',
};

export const fuuzeColorsCss = css`
  --color-dark-100: ${FuuzeColors.dark.dark100};
  --color-dark-200: ${FuuzeColors.dark.dark200};
  --color-dark-300: ${FuuzeColors.dark.dark300};
  --color-dark-400: ${FuuzeColors.dark.dark400};
  --color-dark-500: ${FuuzeColors.dark.dark500};
  --color-dark-600: ${FuuzeColors.dark.dark600};
  --color-dark-700: ${FuuzeColors.dark.dark700};
  --color-dark-800: ${FuuzeColors.dark.dark800};

  --color-orange-20: ${FuuzeColors.orange.orange20};
  --color-orange-30: ${FuuzeColors.orange.orange30};
  --color-orange-40: ${FuuzeColors.orange.orange40};
  --color-orange-50: ${FuuzeColors.orange.orange50};
  --color-orange-60: ${FuuzeColors.orange.orange60};
  --color-orange-70: ${FuuzeColors.orange.orange70};
  --color-orange-80: ${FuuzeColors.orange.orange80};
  --color-orange-90: ${FuuzeColors.orange.orange90};
  --color-orange-100: ${FuuzeColors.orange.orange100};

  --color-yellow: ${FuuzeColors.yellow};
  --color-green: ${FuuzeColors.green};
  --color-red: ${FuuzeColors.red};
  --color-white: ${FuuzeColors.white};
`;

export function filterSvgColorTo(color: 'white'): Pick<CSSProperties, 'filter'> {
  if (color === 'white') {
    return {
      filter:
        'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%)',
    };
  }
  return {};
}
